import { defineMessage } from '@lingui/macro'

import type { MessageDescriptor } from '@lingui/core'
import type { ActivityCardProps } from '@/modules/shared/components/activity-card/ActivityCard.types'
import type { PartialRecord } from '@/utils/typescript'

const activityTypeTranslations: PartialRecord<ActivityCardProps['type'], MessageDescriptor> = {
  Appointment: defineMessage({
    id: 'globals.appointment',
    message: 'Afspraak',
  }),
  Knowledge: defineMessage({ id: 'globals.knowledge', message: 'Informatie' }),
  Task: defineMessage({ id: 'globals.task', message: 'Taak' }),
  Message: defineMessage({
    id: 'globals.message',
    message: 'Bericht',
  }),
  Brochure: defineMessage({
    id: 'globals.brochure',
    message: 'Brochure',
  }),
  Intake: defineMessage({
    id: 'globals.intake',
    message: 'Opname',
  }),
  Document: defineMessage({
    id: 'globals.document',
    message: 'Document',
  }),
  Content: defineMessage({
    id: 'globals.content',
    message: 'Kennis',
  }),
  Communication: defineMessage({
    id: 'globals.communication',
    message: 'Communicatie',
  }),
  Invoice: defineMessage({
    id: 'globals.invoice',
    message: 'Factuur',
  }),
}

export { activityTypeTranslations }
